import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { colors } from '../../features/theme/settings';

const ErrorScreen = () => {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                backgroundColor: colors.themes.blue.primary,
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                gap: '100px',
                justifyContent: 'center',
                minHeight: '100vh',
            }}
        >
            <Typography
                sx={{
                    fontSize: '128px',
                    fontWeight: '600',
                    color: colors.white,
                    '@media (max-width: 700px)': {
                        fontSize: '64px',
                    },
                }}
            >
                404
            </Typography>
            <Typography
                sx={{
                    fontSize: '64px',
                    textTransform: 'uppercase',
                    color: colors.white,
                    '@media (max-width: 700px)': {
                        fontSize: '32px',
                    },
                }}
            >
                {t('page-not-found')}
            </Typography>
        </Box>
    );
};

export default ErrorScreen;
